import { AxiosInstance } from "axios";

const actualizarFormulaServices = (instance: AxiosInstance) => {
  const update = (values) => instance.post("/base-formula/massive", values);
  return {
    update,
  };
};
export default actualizarFormulaServices;
